import { createContext } from 'react';
import type { IdentityUser } from '../auth';

export type UserInfo = IdentityUser;

export interface UserContextValue {
  user: IdentityUser | null;
  isLoading: boolean;
}

export const UserContext = createContext<UserContextValue | null>(null);
